import { useEffect, useState } from "react"
import TextField from "../components/forms/TextField"   
import ImagePickerField from "../components/forms/ImagePickerField"
import { useNavigate, useParams } from "react-router-dom"

import { useDispatch, useSelector } from "react-redux"
import { getSingleCompany, editCompany } from "../redux/companies/CompanySlice"

export default function CompanyEdit() {
    const [submitted, setSubmitted] = useState(false)
    const [submittedCount, setSubmittedCount] = useState(0)
    const [company, setCompany] = useState({})
    const params = useParams()
    const [companyForm, setCompanyForm] = useState(null)
    const navigate = useNavigate()

    const companyRedux = useSelector(state => state.Company)

    const dispatch = useDispatch()

    useEffect(() => {
        if (submitted && !companyRedux.isButtonLoading) {
            navigate(-1)
        }
    }, [companyRedux.isButtonLoading])

    useEffect(() => {
        const companyInfo = companyRedux.companies.filter(company => company.id === params.id).pop()

        if (companyInfo?.id) {
            setCompany(companyInfo)
        } else {
            dispatch(getSingleCompany({ companyId: params.id }))
        }
    }, [companyRedux.companies])

    const submitProductForm = (ev) => {
        ev.preventDefault()
        setSubmitted(true)

        setSubmittedCount(submittedCount + 1)

        let hasError = false
        for (const key in companyForm) {
            if (companyForm[key].isRequired && !companyForm[key].fieldValue || companyForm[key].error) {
                hasError = true
                break
            } else {
                hasError = false
            }
        }

        if (!hasError) {
            const name = companyForm.name.fieldValue
            const logo = companyForm.logo.fieldValue
            const existingLogo = company.logo

            dispatch(editCompany({
                id: params.id,
                name: name,
                logo: logo,
                existingLogo: existingLogo,
                created_date: company.created_date
            }))
        }
    }

    return companyRedux.isSingleLoading ? <div className="flex items-center justify-center"><div role="status">
        <svg aria-hidden="true" className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span className="sr-only">Loading...</span>
    </div> Loading </div> : <>
        <div className='flex mb-20'>
            <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>

                <span className='ml-2'>Back</span>
            </button>
        </div>
        <form onSubmit={submitProductForm}>

            <ImagePickerField
                fieldName="logo"
                label='Company Logo'
                isRequired
                isSubmitted={submitted}
                defaultValue={company.logo}
                onChange={e => setCompanyForm(companyForm => ({...companyForm, logo: e})) }
            />

            <TextField
                fieldName="name"
                label="Company Name"
                isSubmitted={submitted}
                defaultValue={company.name}
                isRequired
                onChange={e => setCompanyForm(companyForm => ({ ...companyForm, name: e }))}
            />



            <button
                type="submit"
                disabled={companyRedux.isButtonLoading}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                {
                    companyRedux.isButtonLoading ? <span className='ml-2'>Saving Changes...</span> : <> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                        <span className='ml-2'>Save Changes</span></>
                }

            </button>
        </form> </>
}